<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="outofhours">

      <c-row>
        <c-col md="6">
          <h1>{{ t('Out of Hours') }}</h1>
        </c-col>
        <c-col md="6" class="text-end"  *ngIf="outofhours.on">

          <div class="btn-group mb-2 " role="group">
              <button type="button" class="btn btn-primary text-white" [class.btn-secondary]="outofhours.on" [class.btn-success]="!outofhours.on" (click)="toggleEnabled(outofhours)">
                <span *ngIf="outofhours.on">{{ t('Disable Out of Hours Alerts') }}</span>
                <span *ngIf="!outofhours.on">{{ t('Enable Out of Hours Alerts') }}</span>
              </button>
              <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353010749841-Setting-Up-Out-of-Hours-Alerts-Evenings-Weekends" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Learn about Out of Hours Alerts') }}</a>
          </div>


        </c-col>
      </c-row>


      <ng-container *ngIf="!outofhours.on">

        <c-row>
        <c-col md="6">
          <p>
            {{ t('Our Out of Hours Alerts service lets you choose the monitors that should be alerted if the alert occurs out of normal business hours. If Alert Loops are active, an Alert Loop can also be used instead of monitors.') }}
          </p>
          <p>
          {{ t('Once activated you can set your business hours and a list of monitors or an alert loop to contact if any alerts occur out of these hours.') }}
          </p>
        </c-col>
        <c-col md="6">
          <div class="card mb-3">
            <div class="card-header">
              {{ t('Activate Out of Hours Alerts') }}
            </div>
            <div class="card-body">


              <ng-container *ngIf="!okService.billing.plan.comms_active">
                <div class="alert alert-warning" role="alert">
                  @if(okService.billing.plan.account_type == "Pricing2024"){
                    <i class="fa-solid fa-triangle-exclamation text-danger"></i>  {{ t('Out of Hours Alerts require the Automated Plan. To set up an automated plan please go to your') }}
                  }@else{
                    <i class="fa-solid fa-triangle-exclamation text-danger"></i>  {{ t('Out of Hours Alerts require the Comms Plan. To set up a comms plan please go to your') }}
                  }
                  <a routerLink="/account/account">{{ t('Account Settings') }}</a>.<br/>
                  <i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about Out of Hours Alerts') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353010749841-Setting-Up-Out-of-Hours-Alerts-Evenings-Weekends" target="_new">{{ t('here') }}</a>.
                </div>
                <button type="button" class="btn btn-primary btn-sm btn-success text-white" disabled="disabled">
                 {{ t('Activate Out of Hours') }}
                </button>
              </ng-container>
              <ng-container *ngIf="okService.billing.plan.comms_active">
                {{ t('Click here to activate Out of Hours alerts on your account...') }}<br/>
                <button type="button" class="btn btn-primary btn-sm btn-success text-white" (click)="toggleEnabled(outofhours)">
                 {{ t('Activate Out of Hours') }}
                </button>
              </ng-container>


            </div>
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-6">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/oIbrIkkJVLk' frameborder='0' allowfullscreen></iframe></div>
        </c-col>
      </c-row>
    </ng-container>
    <ng-container *ngIf="outofhours.on">
      <c-row>
        <c-col class="col-12">
          <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('outofhours_info')">
            <i class="fa-solid fa-circle-info"></i> {{ t('Our Out of Hours Alerts service lets you choose the monitors that should be alerted if the alert occurs out of normal business hours. If Alert Loops are active, an Alert Loop can also be used instead of monitors.') }} {{ t('Once activated you can set your business hours and a list of monitors or an alert loop to contact if any alerts occur out of these hours.') }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('outofhours_info')"></button>
          </div>
        </c-col>
      </c-row>
        <c-row *ngIf="okService.isDismissed('outofhours_info')">
          <p>
            {{ t('Our Out of Hours Alerts service lets you choose the monitors or an alert loop that should be alerted if the alert occurs out of normal business hours.') }}
          </p>
        </c-row>

        <c-row>
          <c-col>
            <h3>{{ t('Business Hours') }}</h3>
            <p>
              {{ t('Please enter your business hours below, where you will use your normal monitor alerts / alert loop.') }}
            </p>

            <div class="alert alert-warning" role="alert" *ngIf="!outofhours.available"><b>Warning!</b> {{ t('To activate Out of Hours alerts, please choose at least one monitor, or an alert loop, and set your out of hours schedule.') }}</div>
            <form class="form-horizontal" [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">
              <table>
                <tr>
                  <td class="text-end">{{ t('Monday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="mon_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="mon_end">
                  </ng-select>
                  </td>
                </tr>

                <tr>
                  <td class="text-end">{{ t('Tuesday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="tue_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="tue_end">
                  </ng-select>
                  </td>
                </tr>

                <tr>
                  <td class="text-end">{{ t('Wednesday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="wed_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="wed_end">
                  </ng-select>
                  </td>
                </tr>
                <tr>
                  <td class="text-end">{{ t('Thursday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="thu_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="thu_end">
                  </ng-select>
                  </td>
                </tr>
                <tr>
                  <td class="text-end">{{ t('Friday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="fri_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="fri_end">
                  </ng-select>
                  </td>
                </tr>
                <tr>
                  <td class="text-end">{{ t('Saturday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="sat_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="sat_end">
                  </ng-select>
                  </td>
                </tr>
                <tr>
                  <td class="text-end">{{ t('Sunday') }} &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="sun_start">
                    </ng-select>
                  </td>
                  <td>&nbsp; {{ t('to') }}  &nbsp;</td>
                  <td>
                    <ng-select
                    [items]="day_hours"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="sun_end">
                  </ng-select>
                  </td>
                </tr>
              </table>

              <div class="row mb-2 mt-2 text-center">
                <div class="col">
                  {{ t('To setup out of hours please choose a monitor or alert loop. If you choose an alert loop it will always be used instead of the monitors.') }}
                </div>
              </div>

              <div class="form-group row mb-2 mt-2" >
                <label class="col-sm-4 col-form-label text-end">
                  <svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}&nbsp;</label>

                <div class="col-sm-6">

                  <ng-select [items]="okService.monitors"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="true"
                            formControlName="monitors"
                            [ngClass]="{ 'border-danger': submitted && f['monitors'].errors }">
                  </ng-select>

                </div>
                <div class="col-sm-2 text-start">
                  <span class="badge bg-success fs-4" *ngIf="outofhours.monitors && outofhours.monitors.length>0 && !outofhours.alert_loop"><i class="fa-solid fa-circle-check"></i></span>
                </div>
                <div *ngIf="submitted && f['monitors'].errors" class="invalid-feedback">
                  <br/>
                  {{ t('A maximum of 4 monitors can be assigned. If you require more monitors then please use our Alert Loops feature.') }}
                </div>
              </div>

              <div class="row mb-2 mt-2 text-center">
                <div class="col"><b>or</b></div>
              </div>


              <div class="form-group row mb-2" *ngIf="okService.alert_loops.length > 0">
                <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilReload"></svg> {{ t('Alert Loop') }}</label>
                <div class="col-sm-6">
                  <ng-select [items]="okService.alert_loops"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="false"
                  formControlName="alert_loop"
                  placeholder="{{ t('None') }}">
                  </ng-select>
                </div>
                <div class="col-sm-2 text-start">
                  <span class="badge bg-success fs-4" *ngIf="outofhours.alert_loop"><i class="fa-solid fa-circle-check"></i></span>
                </div>
              </div>

              <c-row class="mx-3 justify-content-center">



                <div class="alert alert-success" role="alert" *ngIf="outofhours.available && outofhours.monitors.length>0 && !outofhours.alert_loop">
                  {{ t('You have chosen monitors to be alerted out of hours.') }}
                </div>

                <div class="alert alert-success" role="alert" *ngIf="outofhours.available && outofhours.alert_loop">
                  {{ t('You have chosen an alert loop to be used for alerts out of hours.') }}
                </div>

                <div class="alert alert-danger my-1" role="alert" *ngIf="!outofhours.alert_loop && outofhours.monitors.length == 0">{{ t('You must choose at least one monitor or an alert loop for company-wide Out of Hours to work. Individual group Out of Hours can still be used even if the company options are not set.') }}</div>


                <button cButton style="width: fit-content" class=" text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i> {{ t('Save Out of Hours Settings') }}
                </button>

                </c-row>

            </form>
          </c-col>
          <c-col>
            <c-card>
              <c-card-header>
                <h3>{{ t('Business Hours for This Week') }}</h3>
                {{ t('Here are your business hours for this week, any alerts out of these times will be sent to your Out of Hours monitors / alert loop:') }}
              </c-card-header>
              <c-card-body>
                <div class="alert alert-success" role="alert" *ngIf="outofhours.active"><b>{{ t('Notice!') }}</b> {{ t('You are currently in Out of Hours monitoring') }}</div>
                <ul class="list-group">
                  <li class="list-group-item">
                    <b>{{ t('Monday') }}: </b> {{outofhours.week.Monday}}
                  </li>
                  <li class="list-group-item list-group-item-dark">
                    <b>{{ t('Tuesday') }}: </b> {{outofhours.week.Tuesday}}
                  </li>
                  <li class="list-group-item">
                    <b>{{ t('Wednesday') }}: </b> {{outofhours.week.Wednesday}}
                  </li>
                  <li class="list-group-item list-group-item-dark">
                    <b>{{ t('Thursday') }}: </b> {{outofhours.week.Thursday}}
                  </li>
                  <li class="list-group-item">
                    <b>{{ t('Friday') }}: </b> {{outofhours.week.Friday}}
                  </li>
                  <li class="list-group-item list-group-item-dark">
                    <b>{{ t('Saturday') }}: </b> {{outofhours.week.Saturday}}
                  </li>
                  <li class="list-group-item">
                    <b>{{ t('Sunday') }}: </b> {{outofhours.week.Sunday}}
                  </li>
              </ul>
            </c-card-body>



            </c-card>
          </c-col>

        </c-row>
      </ng-container>

  </c-card-body>
</c-card>
